import { ApplicantOfferStatus } from 'api-paths-cas';

export const getApplicationOfferBadgeProps = (status: ApplicantOfferStatus) => {
  switch (status) {
    case ApplicantOfferStatus.Draft: // TODO ENROLY-3304: Remove Draft case after data migration completes
    case ApplicantOfferStatus.Applied:
      return {
        colorScheme: 'cyan',
        children: ApplicantOfferStatus.Applied,
      };
    case ApplicantOfferStatus.Unconditional:
    case ApplicantOfferStatus.Completed:
      return {
        colorScheme: 'green',
        children: ApplicantOfferStatus.Unconditional,
      };
    case ApplicantOfferStatus.Conditional:
      return {
        colorScheme: 'yellow',
        children: ApplicantOfferStatus.Conditional,
      };
    case ApplicantOfferStatus.Withdrawn:
      return {
        colorScheme: 'red',
        children: ApplicantOfferStatus.Withdrawn,
      };
    case ApplicantOfferStatus.Rejected:
      return {
        colorScheme: 'red',
        children: ApplicantOfferStatus.Rejected,
      };
    default:
      return {
        colorScheme: 'transparent',
        children: '',
      };
  }
};
